export class ConfigHelper {

    public static Version: string = '5.9.2';

    public static Projeto: string = 'Atria';

    public static Distribuidor: string = 'Atria';

    public static Url: string = 'https://api.acampa.app/api/';
    
    public static UrlIntergracao: string = 'https://integracao.acampa.app/api/';

    public static UrlStorage: string = 'https://integracao.camptecnologia.com.br/';

    public static UrlCheckList: string = 'https://checklist.acampa.app/';

    public static UrlPesquisaV1: string = 'https://api-pesquisa.acampa.app/v1/atria/';

    public static ApiCheckListV1: string = 'checklist/acampa/v1/';

    public static ApiAnexosV1: string = 'checklist_anexos/acampa/v1/';

    public static Token: string = 'a59e7487cb56a218e6113396e64261981c647603';

    public static TokenDms: string = 'f08Ae54b97c066d0ecSD256f97c0608e54b9ea26d0e54a7RRea2e135';

    public static TokenStorage: string = 'd76e45028a10cfba523b17118f99e2e3';

    public static TokenChecklist: string = '088eceae0ebef44e9b39b83bf1df285f2fd27c9550fc9b319b8df8b3bd5ef25234780156$1$0IM3sqIV$4kfgzIMhpmIXOAgdwDB5W0';

    public static TokenPesquisa: string = 'd76e45028a10cfba523b17118f99e2e3';
    
    public static OneSignalAppId: string = '4e9a2eda-4d43-479d-a00e-46a34793abd9';

    //acampa31
    public static storageKeys = {
        codConcessionaria: 'acampa23_06.codConcessionaria',
        cnpj: 'acampa23_06.cnpj',
        cpf: 'acampa23_06.cpf',
        atualizaautomaticamente: 'acampa23_06.atualizaautomaticamente',
        precoosagregados: 'acampa23_06.precoosagregados',
        concessionaria: 'acampa23_06.concessionaria',
        cardapios1: 'acampa23_06.cardapios1',
        cardapios2: 'acampa23_06.cardapios2',
        marcamodelo: 'acampa23_06.marcamodelo',
        checklistEntrada: 'acampa23_06.checklistEntrada',
        checklistMecanico: 'acampa23_06.checklistMecanico',
        checklistSaida: 'acampa23_06.checklistSaida',
        checklistOrcamento: 'acampa23_06.checklistOrcamento',
        checklistOficina: 'acampa23_06.checklistOficina',
        checklistInspecao: 'acampa23_06.checklistInspecao',
        checklistExtra: 'acampa23_06.checklistExtra',
        cameraAberta: 'acampa23_06.cameraAberta',
        ultimaDataLimpaCache: 'acampa23_06.ultimaDataLimpaCache',
        tiposAnexos: 'acampa23_06.tiposAnexos',
        dataNotificacao: 'acampa23_06.dataNotificacao'
    }

    public static storageKeysSessions = {
        concessionariasAcesso: 'acampa23_06.concessionariasAcesso',
        concessionariasStorage: 'acampa23_06.concessionariasStorage',
        imagensCardapio: 'acampa23_06.imagensCardapio'
    }
}


// WEBPACK FOOTER //
// ./src/app/helpers/configHelper.ts